import { AppDispatch } from '../../../redux/store'
import { showCorrelationIdError } from '../../../redux/correlationIdSlice'
import {
  componentTaxonomyFailure,
  componentTaxonomyRequest,
  componentTaxonomySuccess,
  setConfiguration,
} from '../../../redux/componentTaxonomySlice'
import { getComponentTaxonomy, getComponentTaxonomyConfiguration } from './api'

export const fetchComponentTaxonomy =
  (id: number, onNotFound: () => void) => async (dispatch: AppDispatch) => {
    try {
      dispatch(componentTaxonomyRequest())
      const { data } = await getComponentTaxonomy(id)
      dispatch(componentTaxonomySuccess(data))
    } catch (error: any) {
      if (error.showCorrelationId) {
        dispatch(showCorrelationIdError(error.CorrelationId))
      }
      if (error.response?.status === 400 || error.response?.status === 404) {
        onNotFound()
      }
      dispatch(componentTaxonomyFailure(error.message))
    }
  }

export const loadConfiguration = (id?: number) => async (dispatch: AppDispatch) => {
  try {
    const { data } = await getComponentTaxonomyConfiguration(id)
    dispatch(setConfiguration(data))
  } catch (error: any) {
    if (error.showCorrelationId) {
      dispatch(showCorrelationIdError(error.CorrelationId))
    }
    dispatch(componentTaxonomyFailure(error.message))
  }
}
